document.addEventListener('DOMContentLoaded', () => {
  const statCircles = document.querySelectorAll('.tptai-statistic-feature_stat-circle');

  const animateStat = (circle) => {
    const targetPercent = parseInt(circle.dataset.percentage || circle.style.getPropertyValue('--percentage'), 10);
    let current = 0;

    const numberEl = circle.querySelector('.tptai-statistic-feature_stat-number');
    if (!numberEl) return;

    const interval = setInterval(() => {
      if (current >= targetPercent) {
        clearInterval(interval);
        return;
      }
      current++;
      numberEl.textContent = `${current}%`;
      circle.style.background = `conic-gradient(#d66bc7 0% ${current}%, rgba(214, 107, 199, 0.2) ${current}% 100%)`;
    }, 25);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateStat(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    statCircles.forEach(circle => {
      // Save target percentage
      const percentage = circle.style.getPropertyValue('--percentage') || '0%';
      const cleanPercent = parseInt(percentage, 10);

      // Reset visual + store data
      circle.style.background = `conic-gradient(#d66bc7 0% 0%, rgba(214, 107, 199, 0.2) 0% 100%)`;
      circle.dataset.percentage = cleanPercent;

      const numberEl = circle.querySelector('.tptai-statistic-feature_stat-number');
      if (numberEl) numberEl.textContent = `0%`;

      observer.observe(circle);
    });
  }
});
